import { render } from "./ready.vue?vue&type=template&id=fd79bf10&scoped=true"
const script = {}

import "./ready.vue?vue&type=style&index=0&id=fd79bf10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd79bf10"]])

export default __exports__